import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronRight } from 'icons';
import {
  PaginationFooter,
  PaginationRangeText,
  PaginationNav,
  PaginationBtn,
  PaginationEllipsis,
} from './styles';
import { buildPages } from './helpers';

interface MachinesPaginationProps {
  page: number;
  totalPages: number;
  totalItems: number;
  rangeStart: number;
  rangeEnd: number;
  onPageChange: (p: number) => void;
}

export function MachinesPagination({
  page, totalPages, totalItems, rangeStart, rangeEnd, onPageChange,
}: Readonly<MachinesPaginationProps>): ReactElement {
  const { t } = useTranslation();
  const pages = buildPages(page, totalPages);

  return (
    <PaginationFooter>
      <PaginationRangeText>
        {totalItems === 0
          ? t('zeroItens')
          : t('intervaloPaginacao', { start: rangeStart, end: rangeEnd, total: totalItems })}
      </PaginationRangeText>
      <PaginationNav>
        <PaginationBtn
          type="button"
          onClick={() => onPageChange(page - 1)}
          disabled={page === 1}
        >
          <ChevronRight
            size="12"
            color="currentColor"
            rotate="180deg"
          />
        </PaginationBtn>
        {pages.map((p, i) => (
          p === '…'
            ? <PaginationEllipsis key={i}>…</PaginationEllipsis>
            : (
              <PaginationBtn
                key={i}
                type="button"
                $active={p === page}
                onClick={() => onPageChange(p)}
              >
                {p}
              </PaginationBtn>
            )
        ))}
        <PaginationBtn
          type="button"
          onClick={() => onPageChange(page + 1)}
          disabled={page === totalPages}
        >
          <ChevronRight size="12" color="currentColor" />
        </PaginationBtn>
      </PaginationNav>
    </PaginationFooter>
  );
}
